var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.48855 4.10474H10.3565V0.851125C10.0342 0.806788 8.92591 0.707031 7.63514 0.707031C4.94193 0.707031 3.097 2.4012 3.097 5.51498V8.38065H0.125V12.0179H3.097V21.17H6.74081V12.0188H9.5926L10.0453 8.3815H6.73996V5.87564C6.74081 4.82435 7.02386 4.10474 8.48855 4.10474Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"width":"11","height":"22","viewBox":"0 0 11 22"};

module.exports = Facebook;

Facebook.default = Facebook;
